import { useUser } from "shared/hooks/useAuth";
import { ERoles } from "shared/types/roles";

const useGetUserRole = () => {
  const user = useUser();
  return user?.role as ERoles;
};

export default useGetUserRole;
